/**
 * Created by zcWork on 2016/10/12.
 */
define([], function() {
	var temp = {};

	/**
	 * xml转换为json
	 * @param xml   要转换的xml
	 * @param tab   中间的间隔符
	 * @returns {string}
	 */
	temp.xml2json = function(xml, tab) {
		var X = {
			toObj: function(xml) {
				var o = {};
				if(xml.nodeType == 1) { // element node ..
					if(xml.attributes.length) // element with attributes  ..
						for(var i = 0; i < xml.attributes.length; i++)
							o["@" + xml.attributes[i].nodeName] = (xml.attributes[i].nodeValue || "").toString();
					if(xml.firstChild) { // element has child nodes ..
						var textChild = 0,
							cdataChild = 0,
							hasElementChild = false;
						for(var n = xml.firstChild; n; n = n.nextSibling) {
							if(n.nodeType == 1) hasElementChild = true;
							else if(n.nodeType == 3 && n.nodeValue.match(/[^ \f\n\r\t\v]/)) textChild++; // non-whitespace text
							else if(n.nodeType == 4) cdataChild++; // cdata section node
						}
						if(hasElementChild) {
							if(textChild < 2 && cdataChild < 2) { // structured element with evtl. a single text or/and cdata node ..
								X.removeWhite(xml);
								for(var n = xml.firstChild; n; n = n.nextSibling) {
									if(n.nodeType == 3) // text node
										o["#text"] = X.escape(n.nodeValue);
									else if(n.nodeType == 4) // cdata node
										o["#cdata"] = X.escape(n.nodeValue);
									else if(o[n.nodeName]) { // multiple occurence of element ..
										if(o[n.nodeName] instanceof Array)
											o[n.nodeName][o[n.nodeName].length] = X.toObj(n);
										else
											o[n.nodeName] = [o[n.nodeName], X.toObj(n)];
									} else // first occurence of element..
										o[n.nodeName] = X.toObj(n);
								}
							} else { // mixed content
								if(!xml.attributes.length)
									o = X.escape(X.innerXml(xml));
								else
									o["#text"] = X.escape(X.innerXml(xml));
							}
						} else if(textChild) { // pure text
							if(!xml.attributes.length)
								o = X.escape(X.innerXml(xml));
							else
								o["#text"] = X.escape(X.innerXml(xml));
						} else if(cdataChild) { // cdata
							if(cdataChild > 1)
								o = X.escape(X.innerXml(xml));
							else
								for(var n = xml.firstChild; n; n = n.nextSibling)
									o["#cdata"] = X.escape(n.nodeValue);
						}
					}
					if(!xml.attributes.length && !xml.firstChild) o = null;
				} else if(xml.nodeType == 9) { // document.node
					o = X.toObj(xml.documentElement);
				} else
					console.log("unhandled node type: " + xml.nodeType);
				return o;
			},
			toJson: function(o, name, ind) {
				var json = name ? ("\"" + name + "\"") : "";
				if(o instanceof Array) {
					for(var i = 0, n = o.length; i < n; i++)
						o[i] = X.toJson(o[i], "", ind + "\t");
					json += (name ? ":[" : "[") + (o.length > 1 ? ("\n" + ind + "\t" + o.join(",\n" + ind + "\t") + "\n" + ind) : o.join("")) + "]";
				} else if(o == null)
					json += (name && ":") + "null";
				else if(typeof(o) == "object") {
					var arr = [];
					for(var m in o)
						arr[arr.length] = X.toJson(o[m], m, ind + "\t");
					json += (name ? ":{" : "{") + (arr.length > 1 ? ("\n" + ind + "\t" + arr.join(",\n" + ind + "\t") + "\n" + ind) : arr.join("")) + "}";
				} else if(typeof(o) == "string")
					json += (name && ":") + "\"" + o.toString() + "\"";
				else
					json += (name && ":") + o.toString();
				return json;
			},
			innerXml: function(node) {
				var s = ""
				if("innerHTML" in node)
					s = node.innerHTML;
				else {
					var asXml = function(n) {
						var s = "";
						if(n.nodeType == 1) {
							s += "<" + n.nodeName;
							for(var i = 0; i < n.attributes.length; i++)
								s += " " + n.attributes[i].nodeName + "=\"" + (n.attributes[i].nodeValue || "").toString() + "\"";
							if(n.firstChild) {
								s += ">";
								for(var c = n.firstChild; c; c = c.nextSibling)
									s += asXml(c);
								s += "</" + n.nodeName + ">";
							} else
								s += "/>";
						} else if(n.nodeType == 3)
							s += n.nodeValue;
						else if(n.nodeType == 4)
							s += "<![CDATA[" + n.nodeValue + "]]>";
						return s;
					};
					for(var c = node.firstChild; c; c = c.nextSibling)
						s += asXml(c);
				}
				return s;
			},
			escape: function(txt) {
				return txt.replace(/[\\]/g, "\\\\")
					.replace(/[\"]/g, '\\"')
					.replace(/[\n]/g, '\\n')
					.replace(/[\r]/g, '\\r');
			},
			removeWhite: function(e) {
				e.normalize();
				for(var n = e.firstChild; n;) {
					if(n.nodeType == 3) { // text node
						if(!n.nodeValue.match(/[^ \f\n\r\t\v]/)) { // pure whitespace text node
							var nxt = n.nextSibling;
							e.removeChild(n);
							n = nxt;
						} else
							n = n.nextSibling;
					} else if(n.nodeType == 1) { // element node
						X.removeWhite(n);
						n = n.nextSibling;
					} else // any other node
						n = n.nextSibling;
				}
				return e;
			}
		};
		if(xml.nodeType == 9) // document node
			xml = xml.documentElement;
		var json = X.toJson(X.toObj(X.removeWhite(xml)), xml.nodeName, "\t");
		return "{\n" + tab + (tab ? json.replace(/\t/g, tab) : json.replace(/\t|\n/g, "")) + "\n}";
	};
	temp.json2xml = function(o, tab) {
		var toXml = function(v, name, ind) {
				var xml = "";
				if(v instanceof Array) {
					for(var i = 0, n = v.length; i < n; i++)
						xml += ind + toXml(v[i], name, ind + "\t") + "\n";
				} else if(typeof(v) == "object") {
					var hasChild = false;
					xml += ind + "<" + name;
					for(var m in v) {
						if(m.charAt(0) == "@")
							xml += " " + m.substr(1) + "=\"" + v[m].toString() + "\"";
						else
							hasChild = true;
					}
					xml += hasChild ? ">" : "/>";
					if(hasChild) {
						for(var m in v) {
							if(m == "#text")
								xml += v[m];
							else if(m == "#cdata")
								xml += "<![CDATA[" + v[m] + "]]>";
							else if(m.charAt(0) != "@")
								xml += toXml(v[m], m, ind + "\t");
						}
						xml += (xml.charAt(xml.length - 1) == "\n" ? ind : "") + "</" + name + ">";
					}
				} else {
					xml += ind + "<" + name + ">" + v.toString() + "</" + name + ">";
				}
				return xml;
			},
			xml = "";
		for(var m in o)
			xml += toXml(o[m], m, "");
		return tab ? xml.replace(/\t/g, tab) : xml.replace(/\t|\n/g, "");
	};

	/**
	 * wfs返回的xml转换为DataList可以使用的json格式(only for 北京预警)
	 * @param xmlData   原始的xml数据
	 * @param layerName 图层名（因为北京预警的xml返回值中带有layerName），比如：L3548
	 * @returns {*}
	 */
	temp.wfsXmlToJsonDataArray = function(xmlData, layerName) {
		var self = this;
		var strJsonFromXml = self.xml2json(xmlData, "");
		var jsonDataArray = fnCreateJsonDataArrayNew(strJsonFromXml, layerName);
		return jsonDataArray;
	};
	/**
	 * xmlJson生成jsonDataArray
	 * @param strJsonFromXml
	 * @param layerName 实际已经不使用这个参数
	 * @returns {Array}
	 */
	function fnCreateJsonDataArray(strJsonFromXml, layerName) {
		var jsonFromXml = JSON.parse(strJsonFromXml);
		var result = [];
		var arrayOriginal = jsonFromXml["wfs:FeatureCollection"]["gml:featureMember"];
		for(var i = 0; i < arrayOriginal.length; i++) {
			for(var key in arrayOriginal[i]) {
				break;
			}
			// var oneObject = arrayOriginal[i]["esri:" + layerName];
			var oneObject = arrayOriginal[i][key];
			var oneObjectWanted = {};
			for(var x in oneObject) {
				if(x.indexOf("esri:") == 0) {
					oneObjectWanted[x.substr(5)] = oneObject[x];
				}
			}
			//如果使用find会好点
			var strLatLng = oneObject["gml:envelope"];
			var arrCoor = strLatLng.split(',');
			var xMin = parseFloat(arrCoor[0]);
			var yMin = parseFloat(arrCoor[1]);
			var xMax = parseFloat(arrCoor[2]);
			var yMax = parseFloat(arrCoor[3]);
			oneObjectWanted.longitude = (xMin + xMax) / 2;
			oneObjectWanted.latitude = (yMin + yMax) / 2;
			result.push(oneObjectWanted);
		}
		return result;
	}

	function fnCreateJsonDataArrayNew(strJsonFromXml, layerName) {
		var jsonFromXml = JSON.parse(strJsonFromXml);
		var result = [];
		var arrayOriginal;
		if(jsonFromXml && jsonFromXml["wfs:FeatureCollection"]) {
			arrayOriginal = jsonFromXml["wfs:FeatureCollection"]["gml:featureMember"];
		} else {
			return;
		}

		//存在查询不出任何信息的情况
		if(!arrayOriginal) {
			return;
		}
		//如果是一个单个对象！
		if(arrayOriginal && arrayOriginal.length == undefined) {
			for(var key in arrayOriginal) {
				break;
			}
			result.push(fnDealWithOneObject(arrayOriginal[key]));
		} else {
			for(var i = 0; i < arrayOriginal.length; i++) {
				//因为只有一个键，通过下述方式来得到想要的键值
				for(var key in arrayOriginal[i]) {
					break;
				}
				// var oneObject = arrayOriginal[i]["esri:" + layerName];
				var oneObject = arrayOriginal[i][key];
				var oneObjectWanted = fnDealWithOneObject(oneObject);
				result.push(oneObjectWanted);
			}
		}
		return result;
	}

	//对一个基本object的内容进行处理
	function fnDealWithOneObject(oneObject) {
		var oneObjectWanted = {};
		for(var x in oneObject) {
			if(x.indexOf("esri:") == 0) {
				oneObjectWanted[x.substr(5)] = oneObject[x];
			}
		}
		//如果使用find会好点
		var strLatLng = oneObject["gml:envelope"];
		var arrCoor = strLatLng.split(',');
		var xMin = parseFloat(arrCoor[0]);
		var yMin = parseFloat(arrCoor[1]);
		var xMax = parseFloat(arrCoor[2]);
		var yMax = parseFloat(arrCoor[3]);
		oneObjectWanted.longitude = (xMin + xMax) / 2;
		oneObjectWanted.latitude = (yMin + yMax) / 2;

		//判断是点、线（没有找到哪个表示线）、还是面
		var pointData = oneObject["gml:multiPointProperty"];
		var polylineData = oneObject["gml:multiLineStringProperty"];
		var polygonData = oneObject["gml:multiPolygonProperty"];

		if(pointData) {
			//是点
			var pointMemberArray = pointData["gml:MultiPoint"]["gml:pointMember"];
			var wktOfPoint = "";
			//如果有多个，则被翻译为array，如果是单个，则被翻译为对象object
			if(pointMemberArray.length) {
				wktOfPoint = "MULTIPOINT(";
				oneObjectWanted.wkttype = "MULTIPOINT";
				for(var j = 0; j < pointMemberArray.length; j++) {
					var onePoint = pointMemberArray[j];
					var gmlOfOnePoint = onePoint["gml:Point"]["gml:coordinates"];
					if(j == pointMemberArray.length - 1) {
						wktOfPoint += gmlOfOnePoint;
					} else {
						wktOfPoint += gmlOfOnePoint + ",";
					}
				}
				wktOfPoint += ")";
			} else {
				wktOfPoint += "POINT(";
				oneObjectWanted.wkttype = "POINT";
				wktOfPoint += pointMemberArray["gml:Point"]["gml:coordinates"];
				wktOfPoint += ")";
			}
			oneObjectWanted.wktdata = wktOfPoint;
		}
		if(polylineData) {
			//是线
			var polylineMemberArray = polylineData["gml:MultiLineString"]["gml:lineStringMember"];
			var wktDataOfPolyline = "";
			if(polylineMemberArray.length) {
				//wkt multiLineString
				oneObjectWanted.wkttype = "MULTILINESTRING";
				wktDataOfPolyline += "MULTILINESTRING(";
				for(var j = 0; j < polylineMemberArray.length; j++) {
					var gmlOfPolyline = polylineMemberArray[j]["gml:LineString"]["gml:coordinates"];
					if(j == polylineMemberArray.length - 1) {
						wktDataOfPolyline += "(" + gmlOfPolyline.replace(new RegExp(";", "gm"), ",") + ")";
					} else {
						wktDataOfPolyline += "(" + gmlOfPolyline.replace(new RegExp(";", "gm"), ",") + "),";
					}
				}
				wktDataOfPolyline += ")";
			} else {
				//wkt LineString
				oneObjectWanted.wkttype = "LINESTRING";
				var gmlOfPolyline = polylineMemberArray["gml:LineString"]["gml:coordinates"];
				wktDataOfPolyline += "LINESTRING(";
				wktDataOfPolyline += gmlOfPolyline.replace(new RegExp(";", "gm"), ",");
				wktDataOfPolyline += ")";
			}
			oneObjectWanted.wktdata = wktDataOfPolyline;
		}
		if(polygonData) {
			//是面
			var polygonMemberArray = polygonData["gml:MultiPolygon"]["gml:polygonMember"];
			var wktDataOfPolygon = "";
			if(polygonMemberArray.length) {
				//都按照不存在内多边形的情况来处理，不考虑POLYGON的内多边形情况。
				oneObjectWanted.wkttype = "MULTIPOLYGON";
				wktDataOfPolygon += "MULTIPOLYGON(";
				for(var j = 0; j < polygonMemberArray.length; j++) {
					var onePolygon = polygonMemberArray[j];
					var gmlOfOnePolygon = onePolygon["gml:Polygon"]["gml:outerBoundaryIs"]["gml:LinearRing"]["gml:coordinates"];
					if(j == polygonMemberArray.length - 1) {
						wktDataOfPolygon += "((" + gmlOfOnePolygon.replace(new RegExp(";", "gm"), ",") + "))";
					} else {
						wktDataOfPolygon += "((" + gmlOfOnePolygon.replace(new RegExp(";", "gm"), ",") + ")),";
					}
				}
				wktDataOfPolygon += ")";
			} else {
				oneObjectWanted.wkttype = "POLYGON";
				wktDataOfPolygon += "POLYGON(";
				var gmlOfOnePolygon = polygonMemberArray["gml:Polygon"]["gml:outerBoundaryIs"]["gml:LinearRing"]["gml:coordinates"];
				wktDataOfPolygon += "(" + gmlOfOnePolygon.replace(new RegExp(";", "gm"), ",") + ")";
				wktDataOfPolygon += ")";
			}
			oneObjectWanted.wktdata = wktDataOfPolygon;
		}
		if(!pointData && !polygonData && !polylineData) {
			oneObjectWanted.wkttype = "未知类型";
		}
		return oneObjectWanted;
	}

	return temp;
})